export const setOrPcsByTitle = (productDescription) => {
  if (productDescription) {
    const _description = productDescription.toLowerCase()

    if (_description.includes('sats') || _description.includes('4st')) {
      return 'set'
    }
  }

  return 'pcs'
}